export default "__VITE_ASSET__msrr3eO0__"